import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  // 1. Validar sesión activa
  if (!authService.isAuthenticated()) {
    router.navigate(['/account/login']); // ← Guard navega, no el servicio
    return false;
  }

  // 2. Validar permiso si la ruta lo requiere
  const requiredPermission = route.data?.['permission'] as string | undefined;

  if (requiredPermission) {
    const slugs = (authService.identity() as string[]) ?? [];
    const hasPermission = slugs.includes(requiredPermission);

    if (!hasPermission) {
      router.navigate(['/']);
      return false;
    }
  }

  return true;
};
